// Copyright © 2022 The Things Network Foundation, The Things Industries B.V.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import Yup from '@ttn-lw/lib/yup'

import claimValidationSchema from './gateway-claim-form-section/validation-schema'
import registerValidationSchema from './gateway-registration-form-section/validation-schema'

export const validationSchema = Yup.object({
  _owner_id: Yup.string(),
  _isFleet: Yup.boolean(),
}).when('._inputMethod', {
  is: 'register',
  then: schema => schema.concat(registerValidationSchema),
  otherwise: schema => schema.concat(claimValidationSchema),
})

export default validationSchema
